import { api } from "../AxiosInstance";
import { IUser } from "../interfaces/user.interface";

// Define interfaces for update requests
export interface IUpdateProfileRequest {
  userFullName?: string;
  phoneNumber?: string;
  city?: string;
  state?: string;
  address?: string;
}

export interface IUpdatePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

// Define service functions for general data related API calls
const UserService = {
  getMyProfile: async (): Promise<IUser> => {
    try {
      const response = await api.get("/users/me");
      return response.data; // Return only the data payload
    } catch (error) {
      console.error("Error fetching profile:", error);
      throw error; // Re-throw error for global handling if necessary
    }
  },

  updateProfile: async (updateData: IUpdateProfileRequest): Promise<IUser> => {
    try {
      const response = await api.put("/users/me", updateData);
      return response.data;
    } catch (error) {
      console.error("Error updating profile:", error);
      throw error;
    }
  },

  updatePassword: async (
    passwordData: IUpdatePasswordRequest
  ): Promise<void> => {
    try {
      const response = await api.put("/users/me/password", passwordData);
      return response.data;
    } catch (error) {
      console.error("Error updating password:", error);
      throw error;
    }
  },
};

export default UserService;
